<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="项目概况" name="first" lazy>
      <xmgk :date="date" :dateType="dateType"></xmgk>
    </el-tab-pane>
    <el-tab-pane label="运行能耗" name="second" lazy>
      <yxnh :date="date" :dateType="dateType"></yxnh>
    </el-tab-pane>
    <el-tab-pane label="运行质量" name="third" lazy>
      <yxzl :date="date" :dateType="dateType"></yxzl>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import xmgk from "./ztgy/xmgk";
  import yxnh from "./ztgy/yxnh";
  import yxzl from "./ztgy/yxzl";
  export default {
    name: "ztgy",
    data () {
      return {
        activeName: 'first'
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: { xmgk, yxnh, yxzl },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event);
      },
    },
  };
</script>

<style lang="less">
  .el-tabs {
    .el-tabs__header {
      margin: 0 0 1px;

      .el-tabs__nav-wrap {
        padding-left: 20px;
        background: #f8f8f9;
      }
    }
  }

  .el-tabs--card {
    height: calc(100vh - 210px);
    /* overflow-y: auto; */
  }

  .el-tab-pane {
    height: calc(100vh - 210px);
    overflow-y: auto;
  }
</style>